var render = function render(){
  var _vm$selectedData, _vm$selectedData2, _vm$selectedData3, _vm$selectedData3$mai, _vm$selectedData4, _vm$selectedData4$mai, _vm$selectedData5, _vm$selectedData5$mai, _vm$selectedData6, _vm$selectedData6$mai, _vm$selectedData7, _vm$selectedData8, _vm$selectedData9, _vm$selectedData10, _vm$selectedData11;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    staticClass: "p-4 bg-white rounded shadow-sm",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('h5', {
    staticClass: "mb-3 text-primary font-semibold"
  }, [_vm._v("Job Library Detail")])]), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped mb-0"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-muted w-25"
  }, [_vm._v("Job Code")]), _c('td', {
    staticClass: "font-semibold"
  }, [_vm._v(_vm._s(((_vm$selectedData = _vm.selectedData) === null || _vm$selectedData === void 0 ? void 0 : _vm$selectedData.code) || '-'))])]), _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Job Name")]), _c('td', {
    staticClass: "font-semibold"
  }, [_vm._v(_vm._s(((_vm$selectedData2 = _vm.selectedData) === null || _vm$selectedData2 === void 0 ? void 0 : _vm$selectedData2.name) || '-'))])]), _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Category")]), _c('td', {
    staticClass: "font-semibold text-uppercase"
  }, [_vm._v(" " + _vm._s(((_vm$selectedData3 = _vm.selectedData) === null || _vm$selectedData3 === void 0 ? void 0 : (_vm$selectedData3$mai = _vm$selectedData3.maintenance_component) === null || _vm$selectedData3$mai === void 0 ? void 0 : _vm$selectedData3$mai.component_name) || '-') + " ")])]), _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Equipment")]), _c('td', {
    staticClass: "font-semibold"
  }, [_vm._v(" " + _vm._s(((_vm$selectedData4 = _vm.selectedData) === null || _vm$selectedData4 === void 0 ? void 0 : (_vm$selectedData4$mai = _vm$selectedData4.maintenance_master) === null || _vm$selectedData4$mai === void 0 ? void 0 : _vm$selectedData4$mai.equipment_name) || '-') + " ")])]), _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Job Type")]), _c('td', {
    staticClass: "font-semibold"
  }, [_vm._v(" " + _vm._s(((_vm$selectedData5 = _vm.selectedData) === null || _vm$selectedData5 === void 0 ? void 0 : (_vm$selectedData5$mai = _vm$selectedData5.maintenance_job_type) === null || _vm$selectedData5$mai === void 0 ? void 0 : _vm$selectedData5$mai.job_type_index) || '-') + " ")])]), _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Job Class")]), _c('td', {
    staticClass: "font-semibold"
  }, [_vm._v(" " + _vm._s(((_vm$selectedData6 = _vm.selectedData) === null || _vm$selectedData6 === void 0 ? void 0 : (_vm$selectedData6$mai = _vm$selectedData6.maintenance_job_class) === null || _vm$selectedData6$mai === void 0 ? void 0 : _vm$selectedData6$mai.job_class) || '-') + " ")])]), _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Method")]), _c('td', {
    staticClass: "font-semibold"
  }, [_vm._v(_vm._s(((_vm$selectedData7 = _vm.selectedData) === null || _vm$selectedData7 === void 0 ? void 0 : _vm$selectedData7.method) || '-'))])]), ((_vm$selectedData8 = _vm.selectedData) === null || _vm$selectedData8 === void 0 ? void 0 : _vm$selectedData8.method) == 'CALENDAR' ? _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Interval")]), _c('td', {
    staticClass: "font-semibold"
  }, [_vm._v(" " + _vm._s(_vm.formatInterval(_vm.selectedData)) + " ")])]) : _vm._e(), _c('tr', [_c('td', {
    staticClass: "text-muted align-top"
  }, [_vm._v("Job Description")]), _c('td', {
    staticClass: "font-semibold"
  }, [(_vm$selectedData9 = _vm.selectedData) !== null && _vm$selectedData9 !== void 0 && _vm$selectedData9.job_description ? _c('div', {
    staticClass: "job-description-content",
    domProps: {
      "innerHTML": _vm._s(_vm.selectedData.job_description)
    }
  }) : _c('span', [_vm._v("-")])])]), _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Active")]), _c('td', {
    staticClass: "font-semibold"
  }, [_c('b-badge', {
    attrs: {
      "variant": (_vm$selectedData10 = _vm.selectedData) !== null && _vm$selectedData10 !== void 0 && _vm$selectedData10.active ? 'success' : 'secondary'
    }
  }, [_vm._v(" " + _vm._s((_vm$selectedData11 = _vm.selectedData) !== null && _vm$selectedData11 !== void 0 && _vm$selectedData11.active ? 'Active' : 'Inactive') + " ")])], 1)])])])])]), _vm.counterRows.length ? _c('b-col', {
    staticClass: "mt-4",
    attrs: {
      "cols": "12"
    }
  }, [_c('h5', {
    staticClass: "mb-2 font-semibold"
  }, [_vm._v("Counter Triggers")]), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered align-middle"
  }, [_c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "70%"
    }
  }, [_vm._v("Engine Name")]), _c('th', {
    staticClass: "text-right",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Interval (Hours)")])])]), _c('tbody', _vm._l(_vm.counterRows, function (ctr, i) {
    return _c('tr', {
      key: i
    }, [_c('td', [_vm._v(_vm._s(ctr.engine_label))]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" " + _vm._s(_vm.formatNumber(ctr.interval_hour)) + " ")])]);
  }), 0)])])]) : _vm._e()], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }